var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.str)?_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.str))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }